import {createStyles, Theme} from "@material-ui/core";
import {beigeColor} from "src/main.style";

export const PayWallStyle = (theme: Theme) => createStyles({
  thankYou: {
    transition: 'all .2s ease',
    fontSize:'30px',
    fontWeight:600,
    opacity:1,
    padding:'40px'
  },
  bigDialog : {
    margin: 0,
    minWidth:'100vw',
    maxWidth:'100vw',
    maxHeight: '100vh',
    minHeight: '100vh',
    borderRadius: 0,
    padding: '32px',
    boxSizing: 'border-box',
    paddingBottom:'62px',
    backgroundColor: theme.palette.background.default,
  },
  circle: {
    zIndex: 0,
    position: 'absolute',
    top: '-17.125rem',
    left: '-30.75rem',
    width: '56.25rem',
    height: '56.25rem',
    borderRadius: '56.25rem',
    backgroundColor: beigeColor,
  },
});



// WEBPACK FOOTER //
// ./src/components/common/paywall/PayWall.style.ts